@if (!objectPageV2) {
  <div
    class="media-page object-and-media-page"
    [ngClass]="{'edit': currentObjectService.isEditing,
    'imageFullScreenOpen': imageFullScreen}"
  >
    <div class="media-page__container object-and-media-page__container">
      <div class="media-page__content object-and-media-page__content row" id="artCon">
        <app-section-menu
          [sectionMenuContainer]="sectionMenuContainer"
        ></app-section-menu>

        <app-object-search-menu
          [object]="art"
          [isEditing]="currentObjectService.isEditing"
          [stylingClass]="'media-page'"
        ></app-object-search-menu>

        <div
          class="small-12 medium-12 large-6 large-push-6 columns media-page__media-carousel object-and-media-page__media-carousel"
          id="artifactImgContainer"
        >
          @if (!mediumScreen) {
            <div class="media-page__media-carousel-template object-and-media-page__template">
              <div class="media-page__media-carousel-template-content"></div>
            </div>
          }

          <div class="media-page__media-carousel-container object-and-media-page__media-carousel-content">
            <div
              class="media-page__media-carousel-content"
              [ngClass]="{'selector-enabled': operationContainer?.selectorEnabled}"
            >
              @if (mediaContainer && mediaId) {
                <app-media-carousel
                  [startMediaId]="mediaId"
                  [mediaContainer]="mediaContainer"
                  [sectionsContainer]="operationContainer?.rootSectionsContainer"
                  [curAnn]="currentObjectService.curAnn"
                  [isEditing]="currentObjectService.isEditing"
                  (mediaUpdated)="selectMedia($event)"
                  (openImageFullScreen)="openImageFullScreen($event)"
                ></app-media-carousel>
              }
            </div>

            @if (operationContainer?.selectorEnabled) {
              <app-search-view-selector
                [stylingClass]="'media-page'"
                [selectorContainer]="operationContainer"
              ></app-search-view-selector>
            }
          </div>
        </div>

        <div class="small-12 medium-12 large-2 large-pull-2 columns media-page__object-menus object-menus-container landing-page-top landing-page-top__action-menu">
          @if (operationContainer) {
            <div class=" media-page__object-menus__content">
              @if (!smallObjectMenus) {
                <app-operation-menus-object
                  [operationContainer]="operationContainer"
                ></app-operation-menus-object>
              }
              @else {
                <app-operation-menus-object-small
                  [operationContainer]="operationContainer"
                ></app-operation-menus-object-small>
              }
            </div>
          }
        </div>

        <div class="small-12 medium-12 columns landing-page-main-content">
          @if (operationContainer?.selectorEnabled) {
            <div
              class="overlay"
              (click)="selectorOverlay()"
              (keydown)="null"
            ></div>
          }

          <div class="landing-page-main-content__content" id="innerCon">
            <div class="landing-page-main-content__overview-fields">
              @if (!operationContainer?.rootSectionsContainer) {
                <div
                  class="loading-object-overview-fields"
                  [ngClass]="{'isEditing': currentObjectService.isEditing}"
                >
                  <div class="loading-object-overview-fields__header"></div>

                  <div class="loading-object-overview-fields__line"></div>

                  <div class="loading-object-overview-fields__line"></div>

                  <div class="loading-object-overview-fields__line"></div>

                  <div class="loading-object-overview-fields__line"></div>
                </div>
              }
              @else {
                <app-object-overview-fields
                  [objectView]="operationContainer.rootSectionsContainer.objectView"
                  class="landing-page-main-content__overview-fields-item"
                  [isEditing]="currentObjectService.isEditing"
                ></app-object-overview-fields>
              }
            </div>

            <app-section-menu-scroll
              [sectionMenuContainer]="sectionMenuContainer"
              class="landing-page-lower"
              id="artifactLower"
            >
              <div class="landing-page-lower__container">
                <div
                  class="landing-page-lower__content-tabs-container"
                  [ngClass]="{'isEditing': currentObjectService.isEditing}"
                >
                  @if (!finishedLoading) {
                    <div class="loading-object-content-tabs">
                      <div
                        class="loading-object-content-tabs__selected-first-menu"
                        [ngClass]="{'isEditing': currentObjectService.isEditing}"
                      >
                        <span class="bold text-blue">
                          {{ 'TRANS__OVERVIEW_MENU__OVERVIEW' | translate }}
                        </span>

                        <mat-icon class="text-blue">
                          expand_more
                        </mat-icon>
                      </div>
                    </div>
                  }

                  @if (contentInfo.artifact) {
                    <app-object-content-tabs
                      class="landing-page-lower__content-tabs"
                      [contentInfo]="contentInfo"
                      (finishedLoading)="isFinishedLoading()"
                      [isEditing]="currentObjectService.isEditing"
                    ></app-object-content-tabs>
                  }
                </div>

                <div class="landing-page-lower__content">
                  @if (contentInfo.curListName === 'overview') {
                    <div class="landing-page-lower__overview">
                      @if (operationContainer?.rootSectionsContainer) {
                        <app-object-view-and-edit
                          [isEditing]="currentObjectService.isEditing"
                          [sectionsContainer]="operationContainer.rootSectionsContainer"
                        ></app-object-view-and-edit>
                      }
                    </div>
                  }
                  @else {
                    <div class="landing-page-lower__content-list">
                      <div class="large-12 columns landing-page-lower__content-list__container">
                        <app-object-content-list
                          [contentInfo]="contentInfo"
                          (objectRefresh)="objectRefresh($event)"
                        ></app-object-content-list>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </app-section-menu-scroll>
          </div>
        </div>
      </div>

      @if (operationContainer?.currentOperation) {
        <div class="media-page__action-toolbar">
          @if (operationContainer.currentOperation.$$currentStep && operationContainer.rootSectionsContainer) {
            <app-operation-toolbar
              [operationContainer]="operationContainer" [operationStep]="operationContainer.currentOperation.$$currentStep"
              [selectorEnabled]="operationContainer.selectorEnabled" [stylingClass]="'media-page'"
            ></app-operation-toolbar>
          }
        </div>
      }
    </div>
  </div>
}
@else {
  <app-object-page-layout
    [disableNavigation]="true"
    defaultImageDrawerWidth="50%"
  >
    <app-object-page-heading
      slot="heading"
      [title]="currentObjectService?.currentObject?.artifact_name"
      [loading]="!operationContainer?.rootSectionsContainer"
    ></app-object-page-heading>

    <app-object-page-operations-toolbar
      [disabled]="currentObjectService?.isEditing"
      slot="operations"
      [actions]="headerActions"
      (actionClick)="onOperationClick($event)"
    ></app-object-page-operations-toolbar>

    <app-object-page-search-navigation
      slot="search-navigation"
      [artifactId]="currentObjectService?.currentObject?.artifact_id"
      [searchContext]="currentSearchContext"
      (closeClick)="onCloseClick()"
      (backClick)="onBackClick()"
      (forwardClick)="onForwardClick()">
    </app-object-page-search-navigation>

    @if (!operationContainer?.rootSectionsContainer) {
      <div class="flex justify-center p-4">
        <mat-spinner diameter="20"></mat-spinner>
      </div>
    }
    @else {
      <mat-card class="overview-card">
        @if (operationContainer?.rootSectionsContainer) {
          <app-object-overview-fields-v2
            [objectView]="operationContainer?.rootSectionsContainer?.objectView"
            [isEditing]="currentObjectService?.isEditing"
          ></app-object-overview-fields-v2>
        }
      </mat-card>

      @if (operationContainer?.rootSectionsContainer) {
        <app-object-view-and-edit
          [isEditing]="currentObjectService.isEditing"
          [sectionsContainer]="operationContainer.rootSectionsContainer"
        ></app-object-view-and-edit>
      }


      <div class="media-page__action-toolbar">
        @if (operationContainer?.currentOperation?.$$currentStep && operationContainer?.rootSectionsContainer) {
          <app-operation-toolbar
            [operationContainer]="operationContainer"
            [operationStep]="operationContainer.currentOperation.$$currentStep"
            [selectorEnabled]="operationContainer.selectorEnabled"
            [stylingClass]="'media-page'"
          ></app-operation-toolbar>
        }
      </div>
    }

    <div slot="right-drawer" class="h-full">
      @if (!operationContainer?.rootSectionsContainer) {
        <div class="skeleton-imagedrawer-container">
          <div class="image-container">
            <div class="skeleton"></div>
          </div>

          <div class="thumnails">
            <div class="skeleton"></div>

            <div class="skeleton"></div>

            <div class="skeleton"></div>
          </div>
        </div>
      }
      @else {
        @if (mediaContainer && mediaId) {
          <app-media-carousel
            [startMediaId]="mediaId"
            [mediaContainer]="mediaContainer"
            [sectionsContainer]="operationContainer?.rootSectionsContainer"
            [curAnn]="currentObjectService.curAnn"
            [isEditing]="currentObjectService.isEditing"
            (mediaUpdated)="selectMedia($event)"
            (openImageFullScreen)="openImageFullScreen($event)"
          ></app-media-carousel>
        }
      }
    </div>
  </app-object-page-layout>

  @if (operationContainer && operationContainer?.selectorEnabled) {
    <app-search-view-selector
      [stylingClass]="'media-page'"
      [selectorContainer]="operationContainer"
    ></app-search-view-selector>
  }
}

@if (imageFullScreen) {
  <app-image-full-screen
    class="image-full-screen-container"
    (closeImageFullScreen)="closeImageFullScreen()"
    [mediaContainer]="mediaContainer"
    [curAnn]="currentObjectService.curAnn"
    [toggleAnnotations]="toggleAnnotations"
  ></app-image-full-screen>
}
